import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import SystemPanel from './SystemPanel';
import {BaseCard} from '../../../components/wizard';
import { extendedstyles } from '../../appstyles';

const s:any ={
  root: {
    width: '100%',
    display: 'flex',
    // overflow: 'scroll',
    justifyContent: 'space-between'
  },
  panel: {
    flex: '1 1 auto'
  },
};

class SystemCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("SystemCard");
    this.state = {
      next: true,
      idtype: null,
      idfrom: null,
      fwopen: false
    };
  }

  render = () => {
    const { classes, theme, ...extraProps  } = this.props;
    const {record,data,extras,setItem} = this.props;
    const {photo,idcard} = data.start;
    return (
      <BaseCard
        cardid={'SYSTEM'}
        cardname={'System'}
        cardtitle={'System Information'}
        instruction={'Provide system information for customer'}
        step={3}
        buttons={['START','CANCEL','PREV','NEXT','GUIDE']}
        {...extraProps}
      >
        <SystemPanel 
          data={extraProps.data}
          record={record} 
          extras={extras}
          photo={photo} 
          idcard={idcard}
          setItem={setItem}
          />
      </BaseCard>
    );
  }
}

SystemCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default SystemCard;
